// extracted by mini-css-extract-plugin
export var divider = "_y7-0";